var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackgroundStripes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 619,
    height: 969,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E6EAF1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.782 162L-193 807h163.256L294 162H131.782zM416.46 0L92 644h163.266L578 0H416.46zM457.345 323L133 969h163.036L619 323H457.345z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjE5IiBoZWlnaHQ9Ijk2OSIgdmlld0JveD0iMCAwIDYxOSA5NjkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8ZyBvcGFjaXR5PSIwLjA1Ij4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMxLjc4MiAxNjJMLTE5MyA4MDdILTI5Ljc0NDNMMjk0IDE2MkgxMzEuNzgyWiIgZmlsbD0iI0U2RUFGMSIvPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00MTYuNDYgMEw5MiA2NDRIMjU1LjI2Nkw1NzggMEg0MTYuNDZaIiBmaWxsPSIjRTZFQUYxIi8+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQ1Ny4zNDUgMzIzTDEzMyA5NjlIMjk2LjAzNkw2MTkgMzIzSDQ1Ny4zNDVaIiBmaWxsPSIjRTZFQUYxIi8+DQo8L2c+DQo8L3N2Zz4NCg==";
export { SvgBackgroundStripes as ReactComponent };